module.exports = __webpack_public_path__ + "img/qrcodeButton.a032b287.svg";